import store from '../store'
import { userAuth } from '@/modules/auth';

export default async (to, from, next) => {
  document.title = process.env.VUE_APP_TITLE

  if (to.matched.some((record) => record.meta.title)) {
    document.title = `${process.env.VUE_APP_TITLE} - ${to.meta.title}`
  }

  // Rotas públicas que não precisam de autenticação
  if (to.name == 'jira'){
    next()
    return
  }

  if (to.name == 'jira-v2'){
    next()
    return
  }

  if (to.name == 'splitc'){
    next()
    return
  }

  if (to.name == 'nextqs'){
    next()
    return
  }

  if (to.name == 'freshservice'){
    next()
    return
  }

  if (to.name == 'forgot-password'){
    next()
    return
  }

  if (to.name == 'reset-password'){
    next()
    return
  }

  // Rota de login não precisa de verificação de autenticação
  if (to.name === 'login') {
    next()
    return
  }
    
  // Rotas protegidas - verificar autenticação
  if (!userAuth.hasTokenCookie()){
    next({ name: 'login' })
    return
  } 
  
  if (!userAuth.hasTokenState()) {
    await store.dispatch('auth/ActionSetToken', {
      token: userAuth.getToken(),
    })
  }

  if (!userAuth.isAuthenticated()) {
    try {
      await store.dispatch('auth/ActionLoadSession');
    } catch (error) {
      // A action ActionLoadSession já faz logout (ActionSignOut) em caso de erro
      // Redireciona para login de forma controlada
      console.error('Erro ao carregar sessão:', error);
      next({ name: 'login' });
      return;
    }
  }

  // Verificar permissões específicas da rota
  if (!_.isEmpty(to.meta.permission)) {
    if (_.includes(userAuth.getPermissions(), to.meta.permission)) {
      next()
      return
    } else {
      next({ name: 'forbidden' })
      return
    }
  }

  // Se passou por todas as verificações, permite navegação
  next()
}
